import { Auth as Cognito } from 'aws-amplify';
//import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';

// const isDevelopmentBuild = 'development' === process.env.NODE_ENV;

/** Sentry tracing sample rate for production builds. */
// const SENTRY_SAMPLE_RATE_PROD = 0.7;

/**
 * Sentry environment name.
 *
 * Each environment name is irrevocable -- once logged, it will always remain in
 * Sentry (though they can be hidden).
 *
 * N.B. These names MUST be declared identically across all Sentry projects (e.g.
 * React, JS, PHP, etc.).
 *
 * @see {@link https://docs.sentry.io/platforms/javascript/configuration/environments/}
 */
// const SENTRY_ENV = window.nesnVars?.appEnvironment
//     ?? ( isDevelopmentBuild ? 'local' : 'unknown' );


// Initialize Sentry monitoring for the React app as early as possible.
//
// https://sentry.io/organizations/nesn/projects/nesn-react-app/?project=6241603
//
// N.B. This integration is for the 'nesn-react-app' Sentry project only. It
// does not provide tracking for any other JavaScript entries aside from the
// React app, which is loaded through this file.
// Sentry.init( {
// dsn: 'https://4c706b5dc81846228259f306a862b44c@o1158452.ingest.sentry.io/6241603',
// integrations: [new BrowserTracing()],
//
// environment: SENTRY_ENV,
//
// // Adjust sample rate based on declared Sentry environment.
// //
// // Sentry strongly recommends that production environments should not track
// // 100% of traces.
// tracesSampleRate: ( 'production' === SENTRY_ENV )
// ? SENTRY_SAMPLE_RATE_PROD
// : 1.0,
// } );

/**
 * The main entrypoint for logins and personalization.
 */
const personalization = {
	/**
	 * Initialize authentication and mount the app.
	 */
	async init() {

		this.configureAmplify();

		const { default: App } = await import(
			/* webpackChunkName: "react-app" */
			'../react-app'
		);

		let user = null;
		try {
			user = await Cognito.currentAuthenticatedUser();
		} catch ( err ) {
			// User is not authenticated.
			// eslint-disable-next-line no-console
			window.nesn_debug && console.log( 'user not auth' );
		}

		await App.mount( {
			cognito: {
				client: Cognito,
				user,
			},
		} );
	},

	/**
	 * Configures AWS Amplify modules.
	 */
	configureAmplify() {
		const { cognito } = window.nesnVars;

		Cognito.configure( {
			mandatorySignIn: true,
			region: cognito.region,
			userPoolId: cognito.userPoolId,
			identityPoolId: cognito.identityPoolId,
			userPoolWebClientId: cognito.appClientId,
		} );
	}
};

personalization.init();
